import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { WP_API_URL } from '../config';
import './ArticleDetailPage.css';

function ArticleDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { isAuthenticated } = useAuth();

    const [article, setArticle] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadArticle();
    }, [id]);

    const loadArticle = async () => {
        try {
            const response = await fetch(`${WP_API_URL}/posts/${id}?_embed`);
            const data = await response.json();
            setArticle(data);
            setLoading(false);
        } catch (error) {
            console.error('Erreur:', error);
            setLoading(false);
        }
    };

    const getFeaturedImage = () => {
        try {
            return article._embedded['wp:featuredmedia'][0].source_url;
        } catch {
            return null;
        }
    };

    const handleUnlock = () => {
        if (!isAuthenticated()) {
            navigate('/login');
            return;
        }
        navigate(`/payment-methods/${id}/article`);
    };

    if (loading) {
        return <div className="loading"><div className="spinner"></div></div>;
    }

    if (!article) {
        return <div>Article introuvable</div>;
    }

    const image = getFeaturedImage();
    const isPremium = article.is_premium;

    return (
        <div className="article-detail-page">
            <article className="article-container">
                <header className="article-header">
                    <h1 dangerouslySetInnerHTML={{ __html: article.title.rendered }} />
                    <div className="article-meta">
                        <span>📅 {new Date(article.date).toLocaleDateString('fr-FR')}</span>
                        {isPremium && <span className="badge-premium">💎 PREMIUM</span>}
                    </div>
                </header>

                {image && (
                    <div className="article-featured-image">
                        <img src={image} alt={article.title.rendered} />
                    </div>
                )}

                <div className="article-body">
                    {!isPremium ? (
                        // Article gratuit : contenu complet
                        <div dangerouslySetInnerHTML={{ __html: article.content.rendered }} />
                    ) : (
                        // Article premium : extrait + CTA de déblocage
                        <>
                            <div
                                className="article-excerpt-teaser"
                                dangerouslySetInnerHTML={{ __html: article.excerpt.rendered }}
                            />
                            <div className="article-locked">
                                <div className="unlock-card">
                                    <div className="lock-icon">🔒</div>
                                    <h3>Contenu Premium</h3>
                                    <p>Débloquez cet article pour lire la suite</p>
                                    <div className="article-price">
                                        <span className="prix">
                                            {article.prix_article
                                                ? `${parseInt(article.prix_article).toLocaleString()} FCFA`
                                                : 'Réservé aux abonnés'}
                                        </span>
                                    </div>
                                    <button className="btn-unlock" onClick={handleUnlock}>
                                        Débloquer l'article
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </article>
        </div>
    );
}

export default ArticleDetailPage;